import { ReloadIcon } from "@radix-ui/react-icons"
import { Button } from "src/@/components/ui/button"
import Iconify from "src/components/Iconify"

export function ButtonLoading({
    onClick,
    children,
    variant,
    size,
    className,
    loading,
    disabled
}) {
    return (
        <Button className={className + " h-8"} variant={variant} onClick={onClick} size={size} disabled={disabled || loading}>
            {loading && <Iconify icon="line-md:loading-twotone-loop" className="text-white" />}
            {children}
        </Button>
    )
}
